export default __webpack_public_path__ + "static/media/person2.95a0a7b9.webp";